export enum LabMemberShipActionTypes {
    API_RESPONSE_SUCCESS = '@@labMemberShip/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@labMemberShip/API_RESPONSE_ERROR',

    ADD_LAB_MEMBERSHIP = '@@labMemberShip/ADD_LAB_MEMBERSHIP',
    EDIT_LAB_MEMBERSHIP = '@@labMemberShip/EDIT_LAB_MEMBERSHIP',
    GET_LAB_MEMBERSHIP = '@@labMemberShip/GET_LAB_MEMBERSHIP',
    GET_LAB_MEMBERSHIPS = '@@labMemberShip/GET_LAB_MEMBERSHIPS',
    RESET = '@@labMemberShip/RESET',
    RESET_SUCCESS = '@@labMemberShip/RESET_SUCCESS',
    RESET_ERROR = '@@labMemberShip/RESET_ERROR',
}
